// i18next resource bundles. France defaults to French; every other country
// gets English (spec §16 — applies to all users, not only distributors).
//
// Wired into i18next from src/i18n.js. Components use useTranslation() from
// react-i18next; the active language is set on every login by
// setLanguageFromUser(user) (also called by the App.js boot effect).
//
// Keep this file the SINGLE source of truth for all UI strings. New keys
// follow the namespacing: common.*, login.*, register.*, profile.*,
// header.*, footer.*, catalogue.*, product.*, cart.*, checkout.*,
// shipments.*, wishlists.*, addresses.*, credits.*, bills.*, network.*,
// distributor.*, advInter.*, validation.*, email.*.

export const RESOURCES = {
    fr: {
        translation: {
            common: {
                loading:        "Chargement…",
                empty:          "Aucun résultat",
                back:           "Retour",
                cancel:         "Annuler",
                confirm:        "Confirmer",
                save:           "Enregistrer",
                send:           "Envoyer",
                submit:         "Valider",
                close:          "Fermer",
                edit:           "Modifier",
                delete:         "Supprimer",
                add:            "Ajouter",
                requiredField:  "Ce champ est requis",
                networkError:   "Erreur réseau, veuillez réessayer.",
                serverError:    "Une erreur est survenue.",
                currency:       "Devise",
                total:          "Total",
                quantity:       "Quantité",
                price:          "Prix",
                priceUnit:      "Prix unitaire",
                reference:      "Référence",
                designation:    "Désignation",
                yes:            "Oui",
                no:             "Non",
                search:         "Rechercher",
                actions:        "Actions",
                status:         "Statut",
                date:           "Date",
                name:           "Nom",
                email:          "Email",
                phone:          "Téléphone",
                address:        "Adresse",
                city:           "Ville",
                zipCode:        "Code postal",
                country:        "Pays",
                comment:        "Commentaire",
            },
            login: {
                description:       "Entrez vos identifiants LaGalaxy pour accéder à votre compte",
                title:             "Connexion",
                email:             "Email",
                password:          "Mot de passe",
                submit:            "Me connecter",
                submitting:        "Connexion...",
                notClientYet:      "Vous n'êtes pas encore client Biotech Dental ?",
                becomeClient:      "Devenez client",
                invalidCredentials:"Vos identifiants n'ont pas pu être validés.",
                forgotPassword:    "Mot de passe oublié ?",
            },
            register: {
                title:             "Inscription",
                submit:            "S'inscrire",
                success:           "Inscription réussie",
                emailExists:       "Un compte existe déjà avec cet email.",
            },
            forgotPassword: {
                title:             "Mot de passe oublié",
                description:       "Saisissez votre email pour recevoir un lien de réinitialisation.",
                submit:            "Envoyer",
                success:           "Email envoyé. Vérifiez votre boîte de réception.",
            },
            changePassword: {
                title:             "Changer mon mot de passe",
                current:           "Mot de passe actuel",
                new:                "Nouveau mot de passe",
                confirm:           "Confirmer le nouveau mot de passe",
                mismatch:          "Les mots de passe ne correspondent pas.",
                submit:            "Mettre à jour",
                success:           "Mot de passe modifié.",
            },
            askSignUp: {
                title:             "Demande d'inscription",
                description:       "Remplissez le formulaire pour rejoindre Biotech Dental.",
                shippingCountry:   "Pays de livraison",
                submit:            "Envoyer ma demande",
                success:           "Demande envoyée.",
            },
            profile: {
                title:             "Mon profil",
                nav: {
                    profile:        "Mon profil",
                    wishlists:      "Mes wishlists",
                    orders:         "Mes commandes",
                    credits:        "Mes crédits",
                    bills:          "Mes factures",
                    addresses:      "Carnet d'adresses",
                    clients:        "Mes clients",
                    createOrder:    "Créer une commande",
                    advInterUpload: "Import commandes",
                    logout:         "Se déconnecter",
                },
                account: {
                    sectionInfo:    "Informations",
                    sectionSmileys: "Mes smileys",
                    company:        "Raison sociale",
                    clientCode:     "Numéro client",
                    email:          "Email",
                    save:           "Enregistrer",
                    updated:        "Profil mis à jour.",
                    noSmileys:      "0 Smileys",
                },
                shipments: {
                    title:          "Mes commandes",
                    titleSingle:    "Ma commande {{id}}",
                    empty:          "Vous n'avez aucune commande en cours",
                    noLines:        "Cette commande ne comporte aucune ligne",
                    backToList:     "Mes commandes",
                    creditUsage:    "Utilisation de vos crédits",
                    totalLine:      "Total de la commande :",
                    columns: {
                        number:     "Numéro",
                        date:       "Date",
                        totalHt:    "Total HT",
                        totalTtc:   "Total TTC",
                        status:     "Statut d'expédition",
                        product:    "Produit",
                        unitPriceHt:"PU HT",
                        unitPriceBrutTtc:"PU brut TTC",
                        discount:   "Remise",
                        unitPriceTtc:"PU TTC",
                        quantity:   "Qté",
                        subtotal:   "Sous-total",
                    },
                },
                shipmentAddresses: {
                    title:               "Mon carnet d'adresses",
                    backToCheckout:      "Retour au checkout",
                    defaultBilling:      "Adresse de facturation par défaut",
                    defaultDelivery:     "Adresse de livraison par défaut",
                    sectionDefault:      "Mes adresses par défaut",
                    sectionExtra:        "Mes adresses complémentaires",
                    extraTitle:          "Adresse complémentaire",
                    add:                 "Ajouter une adresse",
                    edit:                "Modifier",
                    emptyExtra:          "Vous n'avez aucune adresse de livraison complémentaire enregistrée",
                },
                addresses: {
                    title:          "Carnet d'adresses",
                    add:            "Ajouter une adresse",
                    edit:           "Modifier",
                    delete:         "Supprimer",
                    empty:          "Aucune adresse enregistrée",
                    label:          "Intitulé",
                    address1:       "Adresse",
                    address2:       "Complément",
                    address3:       "Complément 2",
                    zipCode:        "Code postal",
                    city:           "Ville",
                    country:        "Pays",
                    phone:          "Téléphone",
                    mobile:         "Mobile",
                    fax:            "Fax",
                    save:           "Enregistrer",
                    cancel:         "Annuler",
                    main:           "Principale",
                },
                bills: {
                    title:          "Mes factures",
                    empty:          "Aucune facture",
                    columns: {
                        number:     "Numéro",
                        date:       "Date",
                        amount:     "Montant",
                        status:     "Statut",
                    },
                    paid:           "Payée",
                    pending:        "En attente",
                    download:       "Télécharger",
                },
                credits: {
                    title:          "Mes crédits",
                    empty:          "Aucun crédit disponible",
                    available:      "Disponibles",
                    used:           "Utilisés",
                    columns: {
                        number:     "Numéro",
                        date:       "Date",
                        amount:     "Montant",
                        balance:    "Solde",
                    },
                },
                wishlists: {
                    title:          "Mes wishlists",
                    empty:          "Aucune wishlist",
                    create:         "Créer une wishlist",
                    delete:         "Supprimer",
                    open:           "Ouvrir",
                },
            },
            heroSlider: {
                discover:          "Découvrir",
                oullier: {
                    subtitle:      "Par le Professeur Olivier Oullier",
                    title:         "Président de l'Institut d'Intelligence Artificielle<br/>Directeur scientifique IA",
                    available:     "Disponible maintenant !",
                    cta:           "Acheter",
                },
            },
            header: {
                home:              "Accueil",
                catalogue:         "Catalogue",
                search:            "Rechercher un produit",
                searchPlaceholder: "Référence, nom du produit…",
                myAccount:         "Mon compte",
                cart:              "Panier",
                wishlist:          "Wishlist",
                login:             "Connexion",
                logout:            "Déconnexion",
                createOrder:       "Créer une commande",
            },
            footer: {
                rights:            "Tous droits réservés",
                contactTitle:      "Contactez-nous",
                followTitle:       "Suivez-nous",
                legalTitle:        "Mentions utiles",
                contact:           "Contact",
                legal:             "Mentions légales",
                cgv:               "Conditions générales de vente",
                smileys:           "Réglement du programme Smileys",
                cookies:           "Politique de cookies",
                privacy:           "Politique de confidentialité",
                addressLine1:      "305 All. de Craponne",
                addressLine2:      "13300 Salon-de-Provence",
                copyright:         "Copyright © {{year}} Biotech Dental. Tous droits réservés",
            },
            language: {
                fr: "FR",
                en: "EN",
                switchTo: "Changer de langue",
            },
            catalogue: {
                title:             "Catalogue",
                filters:           "Filtres",
                noResults:         "Aucun produit ne correspond à votre recherche.",
                resultsCount:      "{{count}} résultat(s)",
                sortBy:            "Trier par",
                clearFilters:      "Effacer les filtres",
                topTen:            "Top 10",
                // Top-level catalogue families — translatable generic dental
                // categories. Brand-name children (Kontact, Anthogyr, Astra…)
                // stay untranslated since they're proper product names.
                families: {
                    implantSolutions:    "Solutions implantaires",
                    surgicalInstruments: "Instruments chirurgicaux",
                    prostheticSolutions: "Solutions prothétiques",
                    genericSolutions:    "Solutions génériques",
                    equipment:           "Équipements",
                    regenerationSolutions:"Solutions régénératrices",
                    professionalArea:    "Mon espace professionnel",
                },
                sort: {
                    default:           "Tri par défaut",
                    priceHighToLow:    "Prix - Du plus cher au moins cher",
                    priceLowToHigh:    "Prix - Du moins cher au plus cher",
                    refHighToLow:      "Référence - De A à Z",
                    refLowToHigh:      "Référence - De Z à A",
                },
                sidebar: {
                    searchPlaceholder: "Rechercher un produit ...",
                    category:          "Catégorie",
                    bodyDiameter:      "Diamètre de corps",
                    neckDiameter:      "Diamètre de col",
                    externalDiameter:  "Diamètre externe",
                    length:            "Longueur",
                    angulation:        "Angulation",
                    size:              "Taille",
                    height:            "Hauteur",
                    allCategories:        "Toutes les catégories",
                    allBodyDiameters:     "Tous les diamètres de corps",
                    allNeckDiameters:     "Tous les diamètres de col",
                    allExternalDiameters: "Tous les diamètres externes",
                    allLengths:           "Toutes les longueurs",
                    allAngulations:       "Toutes les angulations",
                    allSizes:             "Toutes les tailles",
                    allHeights:           "Toutes les hauteurs",
                },
                empty:                 "Aucun produit",
                children: {
                    boneLevel:           "Bone Level",
                    perioLevel:          "Perio Level",
                    zircone:             "Zircone",
                    monobloc:            "Monobloc",
                    healingScrews:       "Vis et coiffe de cicatrisation",
                    classicSurgery:      "Chirurgie classique",
                    guidedSurgery:       "Chirurgie guidée",
                    pkRange:             "Gamme PK",
                    osteosynthesisScrew: "Fixation vis ostéosynthèse",
                    flapFixation:        "Fixation lambeau",
                    flapless:            "Flapless",
                    irrigationLines:     "Lignes irrigation",
                    surgicalMotors:      "Moteurs de chirurgie",
                    vitaminD:            "Vitamine D",
                    boneGrafts:          "Greffes osseuses",
                    membranesMatrices:   "Membranes et matrices",
                    hemostaticDevices:   "Dispositifs hémostatiques",
                    modeledBoneRegen:    "Régénération osseuse modélisée",
                    photobiomodulation:  "Photobiomodulation",
                    hyaluronicAcid:      "Acide hyaluronique",
                    instruments:         "Instruments",
                    diagnostic:          "Diagnostic",
                    hygiene:             "Hygiène",
                    whitening:           "Blanchiment",
                    vitaminB:            "Vitamine B",
                },
                // catalogue.nav.* — granular labels for the mega-menu navigation
                // (NewCatalogue.js). Brand and product names (Kontact, SSA-GF,
                // BioScanHealer, SpiderGraft, Pluryal…) are intentionally NOT
                // listed here — they stay verbatim regardless of locale.
                nav: {
                    brushing:                    "Brossage",
                    gammeKontact:                "Gamme Kontact",
                    gammeKontactPerioLevel:      "Gamme Kontact Perio Level",
                    gammeZircone:                "Gamme Zircone",
                    gammeKontactMonobloc:        "Gamme Kontact Monobloc",
                    gammeHug:                    "Gamme HUG",
                    gammeMagnesium:              "Gamme Magnésium",
                    forKontactImplants:          "Pour implants Kontact / N / S / S+ / XL",
                    forKontactKplImplants:       "Pour implants Kontact Perio Level (KPL)",
                    forZirconeImplants:          "Pour implants ZIRCONE",
                    coverScrews:                 "Vis de couverture",
                    healingScrews:               "Vis de cicatrisation",
                    healingScrewKit:             "Kit de vis de cicatrisation",
                    gingivalFormer:              "Façonneur gingival",
                    surgeryKits:                 "Trousses de chirurgie",
                    fullKit:                     "Trousse pleine",
                    emptyKit:                    "Trousse vide",
                    full:                        "Plein",
                    empty:                       "Vide",
                    surgicalStops:               "Butées chirurgicales",
                    singleStops:                 "Butées unitaires",
                    stopKit:                     "Kit de butées",
                    markingDrills:               "Forets de marquage",
                    pilotDrills:                 "Forets pilotes",
                    pilotDrillsKit:              "Kit Forets pilotes",
                    stagedDrills:                "Forets étagés",
                    corticalDrillsForHealing:    "Forets corticaux pour vis de cicatrisation",
                    reamers:                     "Alésoirs",
                    countersinkKpl:              "Countersink pour implants Kontact Perio Level",
                    corticalBursSplus:           "Fraises corticales pour implants Kontact S+",
                    gauges:                      "Jauges",
                    mandrels:                    "Mandrins",
                    drillExtender:               "Prolongateur de foret",
                    screwdriver:                 "Tournevis",
                    adapters:                    "Adaptateurs",
                    spacer:                      "Espaceur",
                    abutmentExtractors:          "Extracteurs de piliers",
                    keys:                        "Clés",
                    key:                         "Clé",
                    drillingGuides:              "Guides de forage",
                    trephinesForExtraction:      "Trépans pour extraction d'implant",
                    fullGuided:                  "Full guided",
                    mastersTube:                 "Masters tube",
                    mastersTubes:                "Masters tubes",
                    guidedSurgeryKit:            "Trousse de chirurgie guidée",
                    pilot:                       "Pilote",
                    screwpinskitScrews:          "Vis Screwpinskit",
                    screwpinskitKit:             "Kit Screwpinskit",
                    autogenousBoneDevice:        "Dispositif De Prélèvement D'os Autogène",
                    drills:                      "Forets",
                    screwdriverShafts:           "Axes de tournevis",
                    handle:                      "Manche",
                    fixInScrews:                 "Vis Fix In",
                    fixInKit:                    "Kit Fix In",
                    mallet:                      "Maillet",
                    impactor:                    "Impacteur",
                    nail:                        "Clou",
                    kit:                         "Kit",
                    flaplessTrephines:           "Trépans Flapless",
                    hugKit:                      "Kit HUG",
                    osteosynthesisScrews:        "Vis d'ostéosynthèse",
                    osteosynthesisScrewdriver:   "Tournevis pour vis d'ostéosynthèse",
                    screwdriverHandle:           "Manche de tournevis",
                    drillForOsteosynthesis:      "Foret pour vis d'osteosynthèse",
                    roundBur:                    "Fraise boule",
                    depthGauge:                  "Jauge de profondeur",
                    pickup:                      "Pickup",
                    profileDrill:                "Profil Drill",
                    zeradrill:                   "Zeradrill",
                    zeratape:                    "Zeratape",
                    surgicalTray:                "Plateau chirurgical",
                    completeSet:                 "Set Complet",
                    abutments:                   "Piliers",
                    straight:                    "Droits",
                    angled:                      "Angulés",
                    conical:                     "Coniques",
                    cadCamTiBase:                "CAD / CAM TI-BASE",
                    provisional:                 "Provisoires",
                    castable:                    "Surcoulables",
                    fitPost:                     "FitPost",
                    uniPost:                     "UniPost",
                    omniPost:                    "OmniPost",
                    nanoPost:                    "NanoPost",
                    isoPost:                     "IsoPost",
                    removable:                   "Amovible",
                    trialAbutments:              "Piliers d'essai",
                    omniPostSsaAbutmentsCaps:    "Piliers et Coiffes OmniPost / SSA",
                    omniPostAbutments:           "Piliers OmniPost",
                    ssaDirectImplantAbutments:   "Piliers SSA Direct Implant",
                    ssaGfCapsOnOmniPost:         "Coiffes SSA-GF (sur OmniPost)",
                    omniPostCaps:                "Coiffes OmniPost",
                    prostheticFittings:          "Accastillage prothétique",
                    prostheticCaps:              "Coiffes prothétiques",
                    healingCaps:                 "Coiffes de cicatrisation",
                    parallelismCaps:             "Coiffes de parallélisme",
                    sleeves:                     "Gaines",
                    abutmentScrews:              "Vis (de pilier , pour vissage angulé)",
                    abutmentScrewsAlt:           "Vis (de pilier, pour vissage angulé)",
                    mandrelsForConical:          "Mandrins pour pilier conique",
                    prosthesisKit:               "Trousse de prothèse",
                    conicalAbutmentKit:          "Kit piliers coniques",
                    impressionTaking:            "Prise d'empreintes",
                    duplicates:                  "Duplicatas",
                    duplicatesDigitalAnalogs:    "Duplicatas et analogues numériques",
                    scanBody:                    "Scan Body",
                    transfersAndScrews:          "Transferts et vis de transfert",
                    bioscanhealer:               "Bioscanhealer",
                    spiderGraft:                 "SpiderGraft",
                    ssaAbutments:                "Piliers SSA",
                    ssaDirectImplant:            "SSA Direct Implant",
                    healingCapsForConical:       "Coiffes de cicatrisation pour piliers coniques",
                    classic:                     "Classique",
                    zerabase:                    "Zerabase",
                    provisionalAbutments:        "Piliers provisoires",
                    prosthesisTray:              "Plateau prothèse",
                    onNobel:                     "Sur Nobel",
                    onStraumann:                 "Sur Straumann",
                    adaptableProducts:           "Produits adaptables",
                    originalProducts:            "Produits originaux",
                    biopower:                    "Biopower",
                    piezoSurgery:                "Piezo chirurgie",
                    isqMeasurement:              "Mesure de l'ISQ",
                    multipeg:                    "Multipeg",
                    osseo100Plus:                "Osseo 100+",
                    electricScrewdriver:         "Visseuse électrique",
                    isd900:                      "ISD900",
                    xenografts:                  "Xénogreffes",
                    collapat:                    "Collapat",
                    cerabone:                    "Cerabone",
                    ceraboneplus:                "Cerabone +",
                    minerossX:                   "Mineross X",
                    minerossXP:                  "Mineross XP",
                    synthetic:                   "Synthétiques",
                    guidorClassicPlus:           "Guidor Easy-Graft Classic +",
                    guidorCrystal:               "Guidor Easy-Graft Crystal",
                    guidorCrystalPlus:           "Guidor Easy-Graft Crystal +",
                    maxresorb:                   "Maxresorb",
                    maxresorbInject:             "Maxresorb inject",
                    neaCova:                     "Nea Cova",
                    jason:                       "Jason",
                    collprotect:                 "Collprotect",
                    permamem:                    "Permamem",
                    novamag:                     "Novamag",
                    screws:                      "Vis",
                    tissueReconstructionMatrices:"Matrices De Reconstruction Tissulaire",
                    mucoderm:                    "Mucoderm",
                    novomatrix:                  "Novomatrix",
                    cones:                       "Cones",
                    collacone:                   "Collacone",
                    sponges:                     "Eponges",
                    collafleece:                 "Collafleece",
                    boneRegeneration:            "Régénération osseuse",
                    your3DCage:                  "Your3DCage",
                    periImplantBoneRegen:        "Régénération osseuse péri-implantaire",
                    atp38:                       "ATP38",
                    fillers:                     "Fillers",
                    pluryalClassic:              "Pluryal Classic",
                    pluryalVolume:               "Pluryal Volume",
                    pluryalLidocaineClassic:     "Pluryal Lidocaïne Classic",
                    pluryalLidocaineVolume:      "Pluryal Lidocaïne Volume",
                    pluryalBiovolume:            "Pluryal Biovolume",
                    cannulas:                    "Canules",
                    oralCare:                    "Oral Care",
                    cosmetics:                   "Cosmétique",
                },
            },
            product: {
                search:               "Rechercher un produit",
                searchPlaceholder:    "Tapez une référence ou un nom de produit",
                searchBarPlaceholder: "Que recherchez-vous ?",
                searchHintMin:        "Merci de saisir une référence ou une désignation dans la barre de recherche",
                searchNoResults:      "Aucun produit ne correspond à ces critères",
                seeAllResults:        "Voir tous les résultats",
                addToCart:            "Ajouter au panier",
                addCartShort:         "Ajouter",
                removeFromCart:       "Retirer du panier",
                addSelected:          "ajouter",
                navigate:             "naviguer",
                added:                "Produit ajouté au panier.",
                unauthorized:         "Ce produit n'est pas autorisé dans votre pays.",
                certificationRequired: "Ce produit nécessite une certification valide, aucune n'est enregistrée pour votre compte.",
                checkFailed:          "Vérification d'autorisation impossible.",
                authorizationError:   "Erreur lors de la vérification du produit.",
                outOfStock:           "Produit indisponible",
                seeDetails:           "Voir le produit",
                stock:                "Stock",
                price:                "Prix",
                discount:             "Remise",
                relatedProducts:      "Produits associés",
            },
            needHelp: {
                title:             "Besoin d'aide ?",
                titleLab:          "Besoin d'aide ? Vous ne trouvez pas votre client ?",
                hours:             "Un assistant des ventes à votre disposition du lundi au vendredi de 8h30 à 18h.",
            },
            cart: {
                title:             "Mon panier",
                sidebarTitle:      "Votre panier",
                sidebarFor:        "Pour le client : {{company}}",
                sidebarEmpty:      "Aucun article",
                sidebarSubtotal:   "Sous-total :",
                sidebarGoToCart:   "Mon panier",
                sidebarNote:       "Ce montant ne tient pas compte de vos tarifs préférentiels, remises et crédits. Le total sera calculé automatiquement après validation de votre panier.",
                empty:             "Votre panier est vide",
                back:              "Retour au catalogue",
                browseCatalog:     "Parcourir notre catalogue",
                checkout:          "Passer la commande",
                remove:            "Supprimer",
                update:            "Mettre à jour",
                subtotal:          "Sous-total",
                total:             "Total",
                totalLine:         "Total de la commande*",
                totalNote:         "*Ce montant ne tient pas compte de vos tarifs préférentiels, remises et crédits. Le total final sera calculé automatiquement après validation de votre panier.",
                discount:          "Remise",
                continueShopping:  "Continuer mes achats",
                validate:          "Valider mon panier",
                stockShort:        "stock",
                addedToast:        "Produit ajouté au panier.",
                removedToast:      "Produit retiré.",
                columns: {
                    product:       "Produit",
                    unitPrice:     "PU TTC",
                    qty:           "Qté",
                    subtotal:      "Sous-total",
                    remove:        "Suppr.",
                },
            },
            smileys: {
                balanceTitle:      "Mon solde de Smileys :",
                noSmileys:         "Aucun Smileys",
                galaxyNotRecognized:"Utilisateur Galaxy non reconnu",
                useMine:           "Utiliser mes Smileys",
                removeDiscount:    "Supprimer la remise",
                insufficient:      "Votre solde de Smileys est insuffisant. Il doit être supérieur à 500 Smileys et supérieur au montant total de la commande hors remises.",
            },
            checkout: {
                title:             "Validation de commande",
                recapTitle:        "Récapitulatif de ma commande",
                editCart:          "Modifier mon panier",
                selectAddressPlaceholder: "Sélectionner une adresse de livraison",
                deliveryAddress:   "Adresse de livraison",
                billingAddress:    "Adresse de facturation",
                paymentMethod:     "Mode de paiement",
                placeOrder:        "Valider la commande",
                placeOrderBtn:     "Passer commande",
                summary:           "Récapitulatif",
                confirm:           "Confirmer la commande",
                back:              "Retour au panier",
                success:           "Commande envoyée.",
                fail:              "Échec de l'envoi de la commande.",
                addressMissing:    "Veuillez sélectionner une adresse de livraison.",
                cartEmpty:         "Votre panier est vide.",
                comment:           "Commentaire",
                creditUsage:       "Utilisation de vos crédits {{type}}",
                labPricing:        "Application des tarifs de votre client",
                smileyDiscount:    "Remise Smileys : {{amount}} €",
                smileyDiscountNote:"La remise s'effectue sur la base du tarif catalogue.",
                totalLine:         "Total de la commande :",
                toast: {
                    saved:         "Votre commande a bien été enregistrée.",
                    addressMissing:"Merci de choisir une adresse de livraison",
                    error:         "Quelque chose s'est mal passé.",
                },
                columns: {
                    product:       "Produit",
                    discount:      "Remise",
                    unitPrice:     "PU TTC",
                    qty:           "Qté",
                    subtotal:      "Sous-total",
                },
            },
            shipments: {
                title:             "Mes commandes",
                number:            "Numéro",
                date:              "Date",
                status:            "Statut",
                totalHt:           "Total HT",
                totalTtc:          "Total TTC",
                see:               "Voir",
                none:              "Aucune commande pour le moment.",
                track:              "Suivre",
            },
            wishlists: {
                title:             "Mes wishlists",
                sidebarTitle:      "Votre wishlist",
                sidebarEmpty:      "Aucun produit",
                sidebarGoToWishlist: "Ma wishlist",
                create:            "Créer une wishlist",
                rename:            "Renommer",
                delete:            "Supprimer",
                deleteConfirm:     "Supprimer cette wishlist ?",
                addItem:           "Ajouter un article",
                empty:             "Aucune wishlist pour le moment.",
                created:           "Wishlist créée.",
            },
            addresses: {
                title:             "Carnet d'adresses",
                add:               "Ajouter une adresse",
                edit:              "Modifier",
                delete:            "Supprimer",
                empty:             "Aucune adresse enregistrée.",
                saved:             "Adresse enregistrée.",
                primary:           "Principale",
                form: {
                    label:         "Intitulé",
                    address1:      "Adresse",
                    address2:      "Complément",
                    zipCode:       "Code postal",
                    city:          "Ville",
                    country:       "Pays",
                    phone:         "Téléphone",
                    submit:        "Enregistrer",
                },
            },
            credits: {
                title:             "Mes crédits",
                empty:             "Aucun crédit disponible.",
                available:         "Disponibles",
                used:              "Utilisés",
            },
            bills: {
                title:             "Mes factures",
                number:            "Numéro",
                date:              "Date",
                amount:            "Montant",
                paid:              "Payée",
                pending:           "En attente",
                download:          "Télécharger",
                none:              "Aucune facture.",
            },
            network: {
                title:             "Mes clients",
                empty:             "Aucun client lié.",
                select:            "Sélectionner",
                orderFor:          "Commander pour ce client",
            },
            distributor: {
                cart: {
                    eyebrow:          "Commande distributeur",
                    title:            "Composer votre commande",
                    empty:            "Votre panier est vide",
                    emptyHint:        "Ajoutez des articles pour continuer",
                    startHelp:        "Recherchez une référence dans la ligne ci-dessous pour démarrer votre commande.",
                    priceNotice:      "Les montants affichés à cette étape sont indicatifs et ne tiennent pas compte de vos tarifs préférentiels, remises et crédits. Aucune commande n'est passée pour le moment — vous pouvez ajouter, retirer ou modifier vos articles autant de fois que nécessaire. Le total définitif sera calculé automatiquement à l'étape suivante, et vous pourrez à tout moment revenir sur cette page sans perdre votre panier.",
                    back:             "Retour au catalogue",
                    checkout:         "Passer la commande",
                    validateAndPrice: "Valider le panier et voir mes prix",
                    line:             "Article",
                    lines:            "Articles",
                    addLine:          "Ajouter une ligne",
                    addMore:          "Ajouter d'autres références",
                    remove:           "Supprimer",
                    updateQty:        "Modifier la quantité",
                },
                checkout: {
                    eyebrow:          "Commande distributeur",
                    title:            "Validation de commande",
                    address:          "Adresse de livraison",
                    addressMissing:   "Veuillez sélectionner une adresse de livraison.",
                    filterAddresses:  "Filtrer les adresses…",
                    selectedHidden:   "Adresse sélectionnée masquée par le filtre",
                    carrier:          "Transporteur",
                    summary:          "Récapitulatif de la commande",
                    submit:           "Valider la commande",
                    success:          "Commande envoyée à l'ADV International.",
                    fail:             "Échec de l'envoi de la commande.",
                    billingAddress:   "Adresse de facturation",
                },
                confirmation: {
                    title:          "Commande enregistrée",
                    reference:      "Référence client",
                    nextStep:       "Notre équipe ADV International va la traiter.",
                },
            },
            advInter: {
                title:                "ADV International",
                dashboard: {
                    eyebrow:          "ADV International",
                    title:            "Traitement des commandes distributeurs",
                    cardUploadEyebrow:"Optionnel",
                    cardUploadTitle:  "Importer un fichier Excel",
                    cardUploadHelp:   "Téléchargez un fichier Excel pour aperçu et appariement à une commande existante. Si aucune ne correspond, vous pourrez créer une nouvelle commande.",
                    cardTemplateEyebrow: "Optionnel",
                    cardTemplateTitle:"Télécharger un modèle vierge",
                    cardTemplateHelp: "Récupérez un modèle Excel pré-formaté que vous pourrez remplir manuellement avant import.",
                    downloadTemplate: "Télécharger le modèle",
                    sectionOrders:    "Commandes",
                    resultsCount_one: "{{count}} résultat",
                    resultsCount_other:"{{count}} résultats",
                    searchPlaceholder:"Référence, code client, raison sociale, pays, ID…",
                    noResults:        "Aucune commande ne correspond à votre recherche.",
                    matchedFound:     "Commande #{{id}} identifiée",
                    matchedView:      "Voir / éditer",
                    matchedNone:      "Aucune commande existante ne correspond à ce fichier.",
                    createFromExcel:  "Créer une commande",
                    parseAction:      "Analyser",
                    parsePreviewTitle:"Aperçu",
                },
                upload: {
                    title:            "Importer une commande distributeur",
                    choose:           "Choisir un fichier Excel",
                    chosen:           "Fichier sélectionné",
                    parse:            "Analyser",
                    parsed:           "Fichier analysé.",
                    parseFailed:      "Impossible d'analyser le fichier.",
                    invalidExtension: "Le fichier doit être un Excel (.xlsx, .xls).",
                    preview:          "Aperçu de la charge ZSOH",
                    send:             "Envoyer à Sage X3",
                    sending:          "Envoi en cours…",
                    success:          "Commande envoyée à Sage X3.",
                    failure:          "Sage X3 a renvoyé une erreur.",
                },
                orders: {
                    awaiting:         "Commandes en attente d'envoi",
                    id:               "ID",
                    customerRef:      "CUSORDREF",
                    client:           "Client",
                    country:          "Pays",
                    createdAt:        "Créée",
                    action:           "Actions",
                    status:           "Statut",
                    none:             "Aucune commande à traiter.",
                    statuses: {
                        active:       "À traiter",
                        exported:     "À envoyer",
                        pending:      "En cours",
                        failed:       "Échec",
                        sent:         "Envoyées",
                        archived:     "Archivées",
                        all:          "Toutes",
                    },
                    actions: {
                        view:         "Voir / éditer",
                        duplicate:    "Dupliquer",
                        archive:      "Archiver (ne pas envoyer)",
                        unarchive:    "Désarchiver",
                        send:         "Envoyer à Sage X3",
                        sendInProgress:"Envoi en cours…",
                        sendDisabledSent:    "Déjà envoyée",
                        sendDisabledArchived:"Désarchiver d'abord",
                        archived:     "Commande archivée",
                        unarchived:   "Commande restaurée",
                        duplicated:   "Commande dupliquée",
                        createdOk:    "Commande créée",
                        createFailed: "Échec de la création",
                    },
                },
                editor: {
                    backToList:       "Retour à la liste",
                    eyebrow:          "Commande distributeur",
                    lockedNotice:     "Cette commande a déjà été envoyée à Sage X3 — les modifications sont désactivées.",
                    customerRef:      "Référence client",
                    clientCode:       "Code client Sage",
                    raisonSociale:    "Raison sociale",
                    addReference:     "Ajouter une référence",
                    addReferencePlaceholder: "Ajouter une référence ou un nom de produit",
                    recalculatePrices:"Recalculer les prix (répartition)",
                    pricesRecalculated:"Prix recalculés",
                    pricesRecalcFailed:"Erreur lors du recalcul des prix",
                    missingClientCode:"Code client manquant pour recalculer les prix",
                    repartitionEmpty: "La répartition n'a pas renvoyé de prix",
                    columns: {
                        ref:          "Réf.",
                        designation:  "Désignation",
                        quantity:     "Qté",
                        grossPrice:   "Prix brut",
                        discount1:    "Rem 1",
                        discount2:    "Rem 2",
                    },
                    removeLine:       "Retirer cette ligne",
                    showZsoh:         "Voir la charge ZSOH",
                    hideZsoh:         "Masquer la charge ZSOH",
                    deliveryAddress:  "Adresse de livraison",
                    noAddresses:      "Aucune adresse pour ce client.",
                    primaryAddress:   "Principale",
                    save:             "Enregistrer",
                    saved:            "Modifications enregistrées",
                    saveFailed:       "Échec de l'enregistrement",
                    saveBeforeSend:   "Veuillez enregistrer vos modifications avant l'envoi",
                    send:             "Envoyer à Sage X3",
                    sendOk:           "Commande envoyée à Sage X3",
                    sendKo:           "Sage X3 a renvoyé une erreur",
                    line_one:         "ligne",
                    line_other:       "lignes",
                    unsaved:          "non enregistré",
                },
            },
            ldaCart: {
                back:                 "Sélectionner un autre client",
                eyebrow:              "Commande laboratoire",
                addMoreReferences:    "Ajouter d'autres références",
                addLine:              "Ajouter une ligne",
                next:                 "Étape suivante",
                emptyCart:            "Votre panier est vide",
                pleaseSelectProduct:  "Merci de sélectionner un produit",
                pleaseSelectLot:      "Merci de sélectionner un lot pour le produit {{ref}}",
                pleaseSelectLotShort: "Merci de sélectionner un lot",
                lotNotEnoughStock:    "Ce lot n'a pas assez de produits disponibles",
                invalidQuantity:      "Merci d'entrer une quantité valide.",
                lotAlreadyAdded:      "Le lot a déjà été ajouté",
                commentPlaceholder:   "Commentaire",
                columns: {
                    product:          "Produit",
                    lot:              "Lot",
                    quantity:         "Qté",
                    stock:            "Stock",
                    comment:          "Commentaire",
                    remove:           "Suppr.",
                },
                addLot:               "Ajouter un lot",
                removeProduct:        "Supprimer le produit",
                removeLot:            "Retirer ce lot",
                removeRow:            "Retirer cette ligne",
                client:               "Client",
                product_one:          "produit",
                product_other:        "produits",
            },
            ldaRecap: {
                backToCart:           "Modifier mon panier",
                eyebrow:              "Récapitulatif de la commande",
                placeOrder:           "Passer commande",
                emptyCart:            "Votre panier est vide",
                orderSaved:           "Commande enregistrée",
                error:                "Quelque chose s'est mal passé.",
                columns: {
                    product:          "Produit",
                    lot:              "Lot",
                    quantity:         "Qté",
                },
            },
            shipmentsExtra: {
                pending:              "En attente",
                pendingHint:          "Commande en attente de transfert",
                etat: {
                    sendFailed:       "Échec d'envoi",
                    toSend:           "À envoyer",
                    inProgress:       "En cours",
                    waiting:          "En attente",
                },
            },
            email: {
                advInterOrderSubject: "Nouvelle commande distributeur — {{customerReference}}",
            },
            validation: {
                deliveryAddressRequired: "Veuillez choisir une adresse de livraison.",
                cartEmpty:               "Le panier est vide.",
                fileRequired:            "Veuillez sélectionner un fichier.",
                invalidEmail:            "Email invalide.",
                tooShort:                "Trop court.",
                tooLong:                 "Trop long.",
            },
        },
    },
    en: {
        translation: {
            common: {
                loading:       "Loading…",
                empty:         "No results",
                back:          "Back",
                cancel:        "Cancel",
                confirm:       "Confirm",
                save:          "Save",
                send:          "Send",
                submit:        "Submit",
                close:         "Close",
                edit:          "Edit",
                delete:        "Delete",
                add:           "Add",
                requiredField: "This field is required",
                networkError:  "Network error, please try again.",
                serverError:   "Something went wrong.",
                currency:      "Currency",
                total:         "Total",
                quantity:      "Quantity",
                price:         "Price",
                priceUnit:     "Unit price",
                reference:     "Reference",
                designation:   "Designation",
                yes:           "Yes",
                no:            "No",
                search:        "Search",
                actions:       "Actions",
                status:        "Status",
                date:          "Date",
                name:          "Name",
                email:         "Email",
                phone:         "Phone",
                address:       "Address",
                city:          "City",
                zipCode:       "Zip code",
                country:       "Country",
                comment:       "Comment",
            },
            login: {
                description:       "Enter your LaGalaxy credentials to access your account",
                title:             "Sign in",
                email:             "Email",
                password:          "Password",
                submit:            "Sign in",
                submitting:        "Signing in...",
                notClientYet:      "Not a Biotech Dental client yet?",
                becomeClient:      "Become a client",
                invalidCredentials:"Your credentials could not be validated.",
                forgotPassword:    "Forgot password?",
            },
            register: {
                title:             "Register",
                submit:            "Register",
                success:           "Registration successful",
                emailExists:       "An account already exists with this email.",
            },
            forgotPassword: {
                title:             "Forgot password",
                description:       "Enter your email to receive a reset link.",
                submit:            "Send",
                success:           "Email sent. Please check your inbox.",
            },
            changePassword: {
                title:             "Change my password",
                current:           "Current password",
                new:               "New password",
                confirm:           "Confirm new password",
                mismatch:          "Passwords do not match.",
                submit:            "Update",
                success:           "Password updated.",
            },
            askSignUp: {
                title:             "Registration request",
                description:       "Fill out the form to join Biotech Dental.",
                shippingCountry:   "Shipping country",
                submit:            "Send my request",
                success:           "Request sent.",
            },
            profile: {
                title:             "My profile",
                nav: {
                    profile:        "My profile",
                    wishlists:      "My wishlists",
                    orders:         "My orders",
                    credits:        "My credits",
                    bills:          "My invoices",
                    addresses:      "Address book",
                    clients:        "My clients",
                    createOrder:    "Create order",
                    advInterUpload: "Import orders",
                    logout:         "Sign out",
                },
                account: {
                    sectionInfo:    "Information",
                    sectionSmileys: "My smileys",
                    company:        "Company name",
                    clientCode:     "Client number",
                    email:          "Email",
                    save:           "Save",
                    updated:        "Profile updated.",
                    noSmileys:      "0 Smileys",
                },
                shipments: {
                    title:          "My orders",
                    titleSingle:    "Order {{id}}",
                    empty:          "You don't have any orders in progress",
                    noLines:        "This order has no lines",
                    backToList:     "My orders",
                    creditUsage:    "Using your credits",
                    totalLine:      "Order total:",
                    columns: {
                        number:     "Number",
                        date:       "Date",
                        totalHt:    "Total excl. VAT",
                        totalTtc:   "Total incl. VAT",
                        status:     "Shipping status",
                        product:    "Product",
                        unitPriceHt:"Unit price excl. VAT",
                        unitPriceBrutTtc:"Gross unit incl. VAT",
                        discount:   "Discount",
                        unitPriceTtc:"Unit incl. VAT",
                        quantity:   "Qty",
                        subtotal:   "Subtotal",
                    },
                },
                shipmentAddresses: {
                    title:               "My address book",
                    backToCheckout:      "Back to checkout",
                    defaultBilling:      "Default billing address",
                    defaultDelivery:     "Default delivery address",
                    sectionDefault:      "My default addresses",
                    sectionExtra:        "My additional addresses",
                    extraTitle:          "Additional address",
                    add:                 "Add an address",
                    edit:                "Edit",
                    emptyExtra:          "You have no additional delivery addresses saved",
                },
                addresses: {
                    title:          "Address book",
                    add:            "Add an address",
                    edit:           "Edit",
                    delete:         "Delete",
                    empty:          "No addresses saved",
                    label:          "Label",
                    address1:       "Address",
                    address2:       "Complement",
                    address3:       "Complement 2",
                    zipCode:        "Zip code",
                    city:           "City",
                    country:        "Country",
                    phone:          "Phone",
                    mobile:         "Mobile",
                    fax:            "Fax",
                    save:           "Save",
                    cancel:         "Cancel",
                    main:           "Primary",
                },
                bills: {
                    title:          "My invoices",
                    empty:          "No invoices",
                    columns: {
                        number:     "Number",
                        date:       "Date",
                        amount:     "Amount",
                        status:     "Status",
                    },
                    paid:           "Paid",
                    pending:        "Pending",
                    download:       "Download",
                },
                credits: {
                    title:          "My credits",
                    empty:          "No credits available",
                    available:      "Available",
                    used:           "Used",
                    columns: {
                        number:     "Number",
                        date:       "Date",
                        amount:     "Amount",
                        balance:    "Balance",
                    },
                },
                wishlists: {
                    title:          "My wishlists",
                    empty:          "No wishlists",
                    create:         "Create a wishlist",
                    delete:         "Delete",
                    open:           "Open",
                },
            },
            heroSlider: {
                discover:          "Discover",
                oullier: {
                    subtitle:      "By Professor Olivier Oullier",
                    title:         "President of the Institute of Artificial Intelligence<br/>Scientific Director for AI",
                    available:     "Available now!",
                    cta:           "Buy",
                },
            },
            header: {
                home:              "Home",
                catalogue:         "Catalogue",
                search:            "Search for a product",
                searchPlaceholder: "Reference, product name…",
                myAccount:         "My account",
                cart:              "Cart",
                wishlist:          "Wishlist",
                login:             "Sign in",
                logout:            "Sign out",
                createOrder:       "Create order",
            },
            footer: {
                rights:            "All rights reserved",
                contactTitle:      "Contact us",
                followTitle:       "Follow us",
                legalTitle:        "Useful links",
                contact:           "Contact",
                legal:             "Legal notice",
                cgv:               "Terms and conditions of sale",
                smileys:           "Smileys program rules",
                cookies:           "Cookie policy",
                privacy:           "Privacy policy",
                addressLine1:      "305 All. de Craponne",
                addressLine2:      "13300 Salon-de-Provence, France",
                copyright:         "Copyright © {{year}} Biotech Dental. All rights reserved",
            },
            language: {
                fr: "FR",
                en: "EN",
                switchTo: "Change language",
            },
            catalogue: {
                title:             "Catalogue",
                filters:           "Filters",
                noResults:         "No products match your search.",
                resultsCount:      "{{count}} result(s)",
                sortBy:            "Sort by",
                clearFilters:      "Clear filters",
                topTen:            "Top 10",
                families: {
                    implantSolutions:    "Implant solutions",
                    surgicalInstruments: "Surgical instruments",
                    prostheticSolutions: "Prosthetic solutions",
                    genericSolutions:    "Generic solutions",
                    equipment:           "Equipment",
                    regenerationSolutions:"Regeneration solutions",
                    professionalArea:    "My professional area",
                },
                sort: {
                    default:           "Default sort",
                    priceHighToLow:    "Price - High to low",
                    priceLowToHigh:    "Price - Low to high",
                    refHighToLow:      "Reference - A to Z",
                    refLowToHigh:      "Reference - Z to A",
                },
                sidebar: {
                    searchPlaceholder: "Search a product...",
                    category:          "Category",
                    bodyDiameter:      "Body diameter",
                    neckDiameter:      "Neck diameter",
                    externalDiameter:  "External diameter",
                    length:            "Length",
                    angulation:        "Angulation",
                    size:              "Size",
                    height:            "Height",
                    allCategories:        "All categories",
                    allBodyDiameters:     "All body diameters",
                    allNeckDiameters:     "All neck diameters",
                    allExternalDiameters: "All external diameters",
                    allLengths:           "All lengths",
                    allAngulations:       "All angulations",
                    allSizes:             "All sizes",
                    allHeights:           "All heights",
                },
                empty:                 "No products",
                children: {
                    boneLevel:           "Bone Level",
                    perioLevel:          "Perio Level",
                    zircone:             "Zirconia",
                    monobloc:            "Monobloc",
                    healingScrews:       "Healing screws & caps",
                    classicSurgery:      "Conventional surgery",
                    guidedSurgery:       "Guided surgery",
                    pkRange:             "PK Range",
                    osteosynthesisScrew: "Osteosynthesis screw fixation",
                    flapFixation:        "Flap fixation",
                    flapless:            "Flapless",
                    irrigationLines:     "Irrigation lines",
                    surgicalMotors:      "Surgical motors",
                    vitaminD:            "Vitamin D",
                    boneGrafts:          "Bone grafts",
                    membranesMatrices:   "Membranes & matrices",
                    hemostaticDevices:   "Hemostatic devices",
                    modeledBoneRegen:    "Modeled bone regeneration",
                    photobiomodulation:  "Photobiomodulation",
                    hyaluronicAcid:      "Hyaluronic acid",
                    instruments:         "Instruments",
                    diagnostic:          "Diagnostic",
                    hygiene:             "Hygiene",
                    whitening:           "Whitening",
                    vitaminB:            "Vitamin B",
                },
                nav: {
                    brushing:                    "Brushing",
                    gammeKontact:                "Kontact Range",
                    gammeKontactPerioLevel:      "Kontact Perio Level Range",
                    gammeZircone:                "Zirconia Range",
                    gammeKontactMonobloc:        "Kontact Monobloc Range",
                    gammeHug:                    "HUG Range",
                    gammeMagnesium:              "Magnesium Range",
                    forKontactImplants:          "For Kontact / N / S / S+ / XL implants",
                    forKontactKplImplants:       "For Kontact Perio Level (KPL) implants",
                    forZirconeImplants:          "For Zirconia implants",
                    coverScrews:                 "Cover screws",
                    healingScrews:               "Healing screws",
                    healingScrewKit:             "Healing screw kit",
                    gingivalFormer:              "Gingival former",
                    surgeryKits:                 "Surgery kits",
                    fullKit:                     "Full kit",
                    emptyKit:                    "Empty kit",
                    full:                        "Full",
                    empty:                       "Empty",
                    surgicalStops:               "Surgical stops",
                    singleStops:                 "Single stops",
                    stopKit:                     "Stop kit",
                    markingDrills:               "Marking drills",
                    pilotDrills:                 "Pilot drills",
                    pilotDrillsKit:              "Pilot drills kit",
                    stagedDrills:                "Staged drills",
                    corticalDrillsForHealing:    "Cortical drills for healing screws",
                    reamers:                     "Reamers",
                    countersinkKpl:              "Countersink for Kontact Perio Level implants",
                    corticalBursSplus:           "Cortical burs for Kontact S+ implants",
                    gauges:                      "Gauges",
                    mandrels:                    "Mandrels",
                    drillExtender:               "Drill extender",
                    screwdriver:                 "Screwdriver",
                    adapters:                    "Adapters",
                    spacer:                      "Spacer",
                    abutmentExtractors:          "Abutment extractors",
                    keys:                        "Keys",
                    key:                         "Key",
                    drillingGuides:              "Drilling guides",
                    trephinesForExtraction:      "Trephines for implant extraction",
                    fullGuided:                  "Full guided",
                    mastersTube:                 "Masters tube",
                    mastersTubes:                "Masters tubes",
                    guidedSurgeryKit:            "Guided surgery kit",
                    pilot:                       "Pilot",
                    screwpinskitScrews:          "Screwpinskit screws",
                    screwpinskitKit:             "Screwpinskit kit",
                    autogenousBoneDevice:        "Autogenous bone harvesting device",
                    drills:                      "Drills",
                    screwdriverShafts:           "Screwdriver shafts",
                    handle:                      "Handle",
                    fixInScrews:                 "Fix In screws",
                    fixInKit:                    "Fix In kit",
                    mallet:                      "Mallet",
                    impactor:                    "Impactor",
                    nail:                        "Nail",
                    kit:                         "Kit",
                    flaplessTrephines:           "Flapless trephines",
                    hugKit:                      "HUG kit",
                    osteosynthesisScrews:        "Osteosynthesis screws",
                    osteosynthesisScrewdriver:   "Screwdriver for osteosynthesis screws",
                    screwdriverHandle:           "Screwdriver handle",
                    drillForOsteosynthesis:      "Drill for osteosynthesis screws",
                    roundBur:                    "Round bur",
                    depthGauge:                  "Depth gauge",
                    pickup:                      "Pickup",
                    profileDrill:                "Profile Drill",
                    zeradrill:                   "Zeradrill",
                    zeratape:                    "Zeratape",
                    surgicalTray:                "Surgical tray",
                    completeSet:                 "Complete set",
                    abutments:                   "Abutments",
                    straight:                    "Straight",
                    angled:                      "Angled",
                    conical:                     "Conical",
                    cadCamTiBase:                "CAD / CAM TI-BASE",
                    provisional:                 "Provisional",
                    castable:                    "Castable",
                    fitPost:                     "FitPost",
                    uniPost:                     "UniPost",
                    omniPost:                    "OmniPost",
                    nanoPost:                    "NanoPost",
                    isoPost:                     "IsoPost",
                    removable:                   "Removable",
                    trialAbutments:              "Trial abutments",
                    omniPostSsaAbutmentsCaps:    "OmniPost / SSA abutments and caps",
                    omniPostAbutments:           "OmniPost abutments",
                    ssaDirectImplantAbutments:   "SSA Direct Implant abutments",
                    ssaGfCapsOnOmniPost:         "SSA-GF caps (on OmniPost)",
                    omniPostCaps:                "OmniPost caps",
                    prostheticFittings:          "Prosthetic fittings",
                    prostheticCaps:              "Prosthetic caps",
                    healingCaps:                 "Healing caps",
                    parallelismCaps:             "Parallelism caps",
                    sleeves:                     "Sleeves",
                    abutmentScrews:              "Screws (abutment, for angled screwing)",
                    abutmentScrewsAlt:           "Screws (abutment, for angled screwing)",
                    mandrelsForConical:          "Mandrels for conical abutment",
                    prosthesisKit:               "Prosthesis kit",
                    conicalAbutmentKit:          "Conical abutments kit",
                    impressionTaking:            "Impression taking",
                    duplicates:                  "Duplicates",
                    duplicatesDigitalAnalogs:    "Duplicates and digital analogs",
                    scanBody:                    "Scan Body",
                    transfersAndScrews:          "Transfers and transfer screws",
                    bioscanhealer:               "BioScanHealer",
                    spiderGraft:                 "SpiderGraft",
                    ssaAbutments:                "SSA abutments",
                    ssaDirectImplant:            "SSA Direct Implant",
                    healingCapsForConical:       "Healing caps for conical abutments",
                    classic:                     "Classic",
                    zerabase:                    "Zerabase",
                    provisionalAbutments:        "Provisional abutments",
                    prosthesisTray:              "Prosthesis tray",
                    onNobel:                     "On Nobel",
                    onStraumann:                 "On Straumann",
                    adaptableProducts:           "Adaptable products",
                    originalProducts:            "Original products",
                    biopower:                    "Biopower",
                    piezoSurgery:                "Piezo surgery",
                    isqMeasurement:              "ISQ measurement",
                    multipeg:                    "Multipeg",
                    osseo100Plus:                "Osseo 100+",
                    electricScrewdriver:         "Electric screwdriver",
                    isd900:                      "ISD900",
                    xenografts:                  "Xenografts",
                    collapat:                    "Collapat",
                    cerabone:                    "Cerabone",
                    ceraboneplus:                "Cerabone +",
                    minerossX:                   "Mineross X",
                    minerossXP:                  "Mineross XP",
                    synthetic:                   "Synthetic",
                    guidorClassicPlus:           "Guidor Easy-Graft Classic +",
                    guidorCrystal:               "Guidor Easy-Graft Crystal",
                    guidorCrystalPlus:           "Guidor Easy-Graft Crystal +",
                    maxresorb:                   "Maxresorb",
                    maxresorbInject:             "Maxresorb inject",
                    neaCova:                     "Nea Cova",
                    jason:                       "Jason",
                    collprotect:                 "Collprotect",
                    permamem:                    "Permamem",
                    novamag:                     "Novamag",
                    screws:                      "Screws",
                    tissueReconstructionMatrices:"Tissue reconstruction matrices",
                    mucoderm:                    "Mucoderm",
                    novomatrix:                  "Novomatrix",
                    cones:                       "Cones",
                    collacone:                   "Collacone",
                    sponges:                     "Sponges",
                    collafleece:                 "Collafleece",
                    boneRegeneration:            "Bone regeneration",
                    your3DCage:                  "Your3DCage",
                    periImplantBoneRegen:        "Peri-implant bone regeneration",
                    atp38:                       "ATP38",
                    fillers:                     "Fillers",
                    pluryalClassic:              "Pluryal Classic",
                    pluryalVolume:               "Pluryal Volume",
                    pluryalLidocaineClassic:     "Pluryal Lidocaïne Classic",
                    pluryalLidocaineVolume:      "Pluryal Lidocaïne Volume",
                    pluryalBiovolume:            "Pluryal Biovolume",
                    cannulas:                    "Cannulas",
                    oralCare:                    "Oral Care",
                    cosmetics:                   "Cosmetics",
                },
            },
            product: {
                search:             "Search for a product",
                searchPlaceholder:  "Type a reference or product name",
                searchBarPlaceholder:"What are you looking for?",
                searchHintMin:      "Please type a reference or product name in the search bar",
                searchNoResults:    "No products match these criteria",
                seeAllResults:      "See all results",
                addToCart:          "Add to cart",
                addCartShort:       "Add",
                removeFromCart:     "Remove from cart",
                addSelected:        "add",
                navigate:           "navigate",
                added:              "Product added to cart.",
                unauthorized:       "This product is not authorized in your country.",
                certificationRequired: "This product requires a valid certification, none is registered for your account.",
                checkFailed:        "Could not verify product authorization.",
                authorizationError: "Error while checking the product.",
                outOfStock:         "Out of stock",
                seeDetails:         "View product",
                stock:              "Stock",
                price:              "Price",
                discount:           "Discount",
                relatedProducts:    "Related products",
            },
            needHelp: {
                title:             "Need help?",
                titleLab:          "Need help? Can't find your client?",
                hours:             "A sales assistant is available Monday to Friday, 8:30 AM to 6:00 PM.",
            },
            cart: {
                title:             "My cart",
                sidebarTitle:      "Your cart",
                sidebarFor:        "For client: {{company}}",
                sidebarEmpty:      "No items",
                sidebarSubtotal:   "Subtotal:",
                sidebarGoToCart:   "Go to cart",
                sidebarNote:       "This amount doesn't include your preferential pricing, discounts or credits. The final total will be calculated after you validate your cart.",
                empty:             "Your cart is empty",
                back:              "Back to catalogue",
                browseCatalog:     "Browse our catalogue",
                checkout:          "Proceed to checkout",
                remove:            "Remove",
                update:            "Update",
                subtotal:          "Subtotal",
                total:             "Total",
                totalLine:         "Order total*",
                totalNote:         "*This amount does not include your preferential pricing, discounts or credits. The final total will be calculated automatically after you validate your cart.",
                discount:          "Discount",
                continueShopping:  "Continue shopping",
                validate:          "Validate my cart",
                stockShort:        "stock",
                addedToast:        "Product added to cart.",
                removedToast:      "Product removed.",
                columns: {
                    product:       "Product",
                    unitPrice:     "Unit price",
                    qty:           "Qty",
                    subtotal:      "Subtotal",
                    remove:        "Del.",
                },
            },
            smileys: {
                balanceTitle:      "My Smileys balance:",
                noSmileys:         "No Smileys",
                galaxyNotRecognized:"Galaxy user not recognized",
                useMine:           "Use my Smileys",
                removeDiscount:    "Remove discount",
                insufficient:      "Your Smileys balance is too low. It must be over 500 and greater than the total order amount before discounts.",
            },
            checkout: {
                title:             "Order validation",
                recapTitle:        "Order summary",
                editCart:          "Edit my cart",
                selectAddressPlaceholder: "Select a delivery address",
                deliveryAddress:   "Delivery address",
                billingAddress:    "Billing address",
                paymentMethod:     "Payment method",
                placeOrder:        "Place order",
                placeOrderBtn:     "Place order",
                summary:           "Summary",
                confirm:           "Confirm order",
                back:              "Back to cart",
                success:           "Order sent.",
                fail:              "Order submission failed.",
                addressMissing:    "Please select a delivery address.",
                cartEmpty:         "Your cart is empty.",
                comment:           "Comment",
                creditUsage:       "Using your {{type}} credits",
                labPricing:        "Applying your client's pricing",
                smileyDiscount:    "Smileys discount: {{amount}} €",
                smileyDiscountNote:"The discount is applied on the catalogue price.",
                totalLine:         "Order total:",
                toast: {
                    saved:         "Your order has been saved.",
                    addressMissing:"Please choose a delivery address",
                    error:         "Something went wrong.",
                },
                columns: {
                    product:       "Product",
                    discount:      "Discount",
                    unitPrice:     "Unit price",
                    qty:           "Qty",
                    subtotal:      "Subtotal",
                },
            },
            shipments: {
                title:             "My orders",
                number:            "Number",
                date:              "Date",
                status:            "Status",
                totalHt:           "Total excl. VAT",
                totalTtc:          "Total incl. VAT",
                see:               "View",
                none:              "No orders yet.",
                track:             "Track",
            },
            wishlists: {
                title:             "My wishlists",
                sidebarTitle:      "Your wishlist",
                sidebarEmpty:      "No products",
                sidebarGoToWishlist: "Go to wishlist",
                create:            "Create a wishlist",
                rename:            "Rename",
                delete:            "Delete",
                deleteConfirm:     "Delete this wishlist?",
                addItem:           "Add item",
                empty:             "No wishlists yet.",
                created:           "Wishlist created.",
            },
            addresses: {
                title:             "Address book",
                add:               "Add an address",
                edit:              "Edit",
                delete:            "Delete",
                empty:             "No addresses saved.",
                saved:             "Address saved.",
                primary:           "Primary",
                form: {
                    label:         "Label",
                    address1:      "Address",
                    address2:      "Complement",
                    zipCode:       "Zip code",
                    city:          "City",
                    country:       "Country",
                    phone:         "Phone",
                    submit:        "Save",
                },
            },
            credits: {
                title:             "My credits",
                empty:             "No credits available.",
                available:         "Available",
                used:              "Used",
            },
            bills: {
                title:             "My invoices",
                number:            "Number",
                date:              "Date",
                amount:            "Amount",
                paid:              "Paid",
                pending:           "Pending",
                download:          "Download",
                none:              "No invoices.",
            },
            network: {
                title:             "My clients",
                empty:             "No clients linked.",
                select:            "Select",
                orderFor:          "Order for this client",
            },
            distributor: {
                cart: {
                    eyebrow:          "Distributor order",
                    title:            "Compose your order",
                    empty:            "Your cart is empty",
                    emptyHint:        "Add items to continue",
                    startHelp:        "Search a reference in the row below to start your order.",
                    priceNotice:      "The amounts shown on this page are indicative and do not reflect your preferential pricing, discounts or credits. No order is being placed at this step — you can add, remove or edit items as many times as you need. The final total will be calculated automatically at the next step, and you can return to this page at any time without losing your cart.",
                    back:             "Back to catalogue",
                    checkout:         "Proceed to checkout",
                    validateAndPrice: "Validate cart and see my prices",
                    line:             "Item",
                    lines:            "Items",
                    addLine:          "Add a line",
                    addMore:          "Add more references",
                    remove:           "Remove",
                    updateQty:        "Update quantity",
                },
                checkout: {
                    eyebrow:          "Distributor order",
                    title:            "Order validation",
                    address:          "Delivery address",
                    addressMissing:   "Please select a delivery address.",
                    filterAddresses:  "Filter addresses…",
                    selectedHidden:   "Selected address hidden by filter",
                    carrier:          "Carrier",
                    summary:          "Order summary",
                    submit:           "Submit order",
                    success:          "Order sent to ADV International.",
                    fail:             "Order submission failed.",
                    billingAddress:   "Billing address",
                },
                confirmation: {
                    title:          "Order recorded",
                    reference:      "Customer reference",
                    nextStep:       "Our ADV International team will process it.",
                },
            },
            advInter: {
                title:                "ADV International",
                dashboard: {
                    eyebrow:          "ADV International",
                    title:            "Distributor order processing",
                    cardUploadEyebrow:"Optional",
                    cardUploadTitle:  "Import an Excel file",
                    cardUploadHelp:   "Upload an Excel file for preview and matching to an existing order. If none matches, you can create a new one.",
                    cardTemplateEyebrow: "Optional",
                    cardTemplateTitle:"Download a blank template",
                    cardTemplateHelp: "Get a pre-formatted Excel template you can fill in manually before upload.",
                    downloadTemplate: "Download template",
                    sectionOrders:    "Orders",
                    resultsCount_one: "{{count}} result",
                    resultsCount_other:"{{count}} results",
                    searchPlaceholder:"Reference, client code, company, country, ID…",
                    noResults:        "No orders match your search.",
                    matchedFound:     "Order #{{id}} matched",
                    matchedView:      "View / edit",
                    matchedNone:      "No existing order matches this file.",
                    createFromExcel:  "Create order",
                    parseAction:      "Parse",
                    parsePreviewTitle:"Preview",
                },
                upload: {
                    title:            "Import distributor order",
                    choose:           "Choose an Excel file",
                    chosen:           "File selected",
                    parse:            "Parse",
                    parsed:           "File parsed.",
                    parseFailed:      "Could not parse the file.",
                    invalidExtension: "File must be an Excel (.xlsx, .xls).",
                    preview:          "ZSOH payload preview",
                    send:             "Send to Sage X3",
                    sending:          "Sending…",
                    success:          "Order sent to Sage X3.",
                    failure:          "Sage X3 returned an error.",
                },
                orders: {
                    awaiting:         "Orders awaiting forward",
                    id:               "ID",
                    customerRef:      "CUSORDREF",
                    client:           "Client",
                    country:          "Country",
                    createdAt:        "Created",
                    action:           "Actions",
                    status:           "Status",
                    none:             "No orders to process.",
                    statuses: {
                        active:       "To process",
                        exported:     "To send",
                        pending:      "In progress",
                        failed:       "Failed",
                        sent:         "Sent",
                        archived:     "Archived",
                        all:          "All",
                    },
                    actions: {
                        view:         "View / edit",
                        duplicate:    "Duplicate",
                        archive:      "Archive (don't send)",
                        unarchive:    "Unarchive",
                        send:         "Send to Sage X3",
                        sendInProgress:"Sending…",
                        sendDisabledSent:    "Already sent",
                        sendDisabledArchived:"Unarchive first",
                        archived:     "Order archived",
                        unarchived:   "Order restored",
                        duplicated:   "Order duplicated",
                        createdOk:    "Order created",
                        createFailed: "Order creation failed",
                    },
                },
                editor: {
                    backToList:       "Back to list",
                    eyebrow:          "Distributor order",
                    lockedNotice:     "This order has already been sent to Sage X3 — edits are disabled.",
                    customerRef:      "Customer reference",
                    clientCode:       "Sage client code",
                    raisonSociale:    "Company name",
                    addReference:     "Add a reference",
                    addReferencePlaceholder: "Add a reference or product name",
                    recalculatePrices:"Recalculate prices (repartition)",
                    pricesRecalculated:"Prices recalculated",
                    pricesRecalcFailed:"Failed to recalculate prices",
                    missingClientCode:"Client code is missing for repartition",
                    repartitionEmpty: "Repartition returned no prices",
                    columns: {
                        ref:          "Ref.",
                        designation:  "Designation",
                        quantity:     "Qty",
                        grossPrice:   "Gross price",
                        discount1:    "Disc. 1",
                        discount2:    "Disc. 2",
                    },
                    removeLine:       "Remove this line",
                    showZsoh:         "Show ZSOH payload",
                    hideZsoh:         "Hide ZSOH payload",
                    deliveryAddress:  "Delivery address",
                    noAddresses:      "No address for this client.",
                    primaryAddress:   "Primary",
                    save:             "Save",
                    saved:            "Changes saved",
                    saveFailed:       "Failed to save changes",
                    saveBeforeSend:   "Please save your changes before sending",
                    send:             "Send to Sage X3",
                    sendOk:           "Order sent to Sage X3",
                    sendKo:           "Sage X3 returned an error",
                    line_one:         "line",
                    line_other:       "lines",
                    unsaved:          "unsaved",
                },
            },
            ldaCart: {
                back:                 "Select another client",
                eyebrow:              "Lab order",
                addMoreReferences:    "Add more references",
                addLine:              "Add a line",
                next:                 "Next step",
                emptyCart:            "Your cart is empty",
                pleaseSelectProduct:  "Please select a product",
                pleaseSelectLot:      "Please select a lot for product {{ref}}",
                pleaseSelectLotShort: "Please select a lot",
                lotNotEnoughStock:    "This lot doesn't have enough stock",
                invalidQuantity:      "Please enter a valid quantity.",
                lotAlreadyAdded:      "Lot already added",
                commentPlaceholder:   "Comment",
                columns: {
                    product:          "Product",
                    lot:              "Lot",
                    quantity:         "Qty",
                    stock:            "Stock",
                    comment:          "Comment",
                    remove:           "Del.",
                },
                addLot:               "Add a lot",
                removeProduct:        "Remove product",
                removeLot:            "Remove this lot",
                removeRow:            "Remove this row",
                client:               "Client",
                product_one:          "product",
                product_other:        "products",
            },
            ldaRecap: {
                backToCart:           "Edit my cart",
                eyebrow:              "Order recap",
                placeOrder:           "Place order",
                emptyCart:            "Your cart is empty",
                orderSaved:           "Order saved",
                error:                "Something went wrong.",
                columns: {
                    product:          "Product",
                    lot:              "Lot",
                    quantity:         "Qty",
                },
            },
            shipmentsExtra: {
                pending:              "Pending",
                pendingHint:          "Order awaiting transfer",
                etat: {
                    sendFailed:       "Send failed",
                    toSend:           "To send",
                    inProgress:       "In progress",
                    waiting:          "Waiting",
                },
            },
            email: {
                advInterOrderSubject: "New distributor order — {{customerReference}}",
            },
            validation: {
                deliveryAddressRequired: "Please choose a delivery address.",
                cartEmpty:               "Cart is empty.",
                fileRequired:            "Please select a file.",
                invalidEmail:            "Invalid email.",
                tooShort:                "Too short.",
                tooLong:                 "Too long.",
            },
        },
    },
};

/**
 * ISO 3166-1 alpha-2 country codes where French is an official, majority,
 * or co-official language — these all default the UI to French.
 *
 * Source: OIF / official language declarations. Canada is intentionally
 * EXCLUDED because outside Quebec the default is English; explicit override
 * to "fr" can be added later if needed.
 *
 * Used by localeForUser() below.
 */
export const FRENCH_SPEAKING_COUNTRIES = new Set([
    // Europe
    "FR", "BE", "LU", "MC", "CH", "AD",
    // North + West Africa
    "DZ", "MA", "TN", "MR",
    "SN", "ML", "BF", "NE", "CI", "TG", "BJ", "GN",
    // Central Africa
    "CM", "GA", "CG", "CD", "CF", "TD", "GQ",
    // East Africa / Indian Ocean
    "DJ", "KM", "MG", "RW", "BI", "SC",
    // Caribbean / Atlantic
    "HT",
    // French overseas territories / collectivities
    "GP", "MQ", "GF", "RE", "YT", "BL", "MF", "PM",
    // Pacific
    "NC", "PF", "WF",
    // Levant (co-official / large francophone diaspora)
    "LB",
    // Other
    "VU",
]);

/**
 * Returns the locale code to use for a given user (spec §16).
 *   - billing_country_code in FRENCH_SPEAKING_COUNTRIES  → "fr"
 *   - billing_country_code missing/empty                 → "fr" (fallback)
 *   - any other country code                             → "en"
 */
export const localeForUser = (user) => {
    const country = (user && user.billing_country_code) || "";
    if (!country) return "fr";
    return FRENCH_SPEAKING_COUNTRIES.has(country.toUpperCase()) ? "fr" : "en";
};
